"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IBlueprintDataSchema = exports.IIntentSchema = exports.IIntentSlotSchema = exports.ISlotTypeSchema = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const data_1 = require("@citibot/data");
const account_intent_model_1 = require("../schema/account-intent.model");
exports.ISlotTypeSchema = yup_lib_1.default.object().shape({
    name: yup_lib_1.default.string().required(),
    description: yup_lib_1.default.string().optional().min(0).max(200),
    valueSelectionStrategy: yup_lib_1.default
        .string()
        .oneOf(data_1.SlotTypeResolutionStrategyArray)
        .optional()
        .default(data_1.SlotTypeResolutionStrategyEnum.TOP_RESOLUTION),
    enumerationValues: yup_lib_1.default
        .array()
        .of(yup_lib_1.default.object().shape({
        value: yup_lib_1.default.string().required(),
        synonyms: yup_lib_1.default.array().of(yup_lib_1.default.string()).optional()
    }))
        .required()
});
exports.IIntentSlotSchema = yup_lib_1.default.object().shape({
    name: yup_lib_1.default.string().required(),
    slotConstraint: yup_lib_1.default.string().required(),
    priority: yup_lib_1.default.number().required(),
    maxAttempts: yup_lib_1.default.number().required(),
    ellicitedMessage: yup_lib_1.default.string().optional().min(0).max(200),
    obfuscationSetting: yup_lib_1.default
        .string()
        .oneOf(data_1.ObfuscationSettingsOptions)
        .optional()
        .default(data_1.ObfuscationSettingsOptionEnum.None),
    slotType: yup_lib_1.default.string().required()
});
exports.IIntentSchema = yup_lib_1.default.object().shape({
    name: yup_lib_1.default.string().required(),
    utterances: yup_lib_1.default.array().of(yup_lib_1.default.string().required()).optional(),
    confirmationPrompt: account_intent_model_1.PromptContentSchema.notRequired(),
    rejectionStatement: account_intent_model_1.PromptContentSchema.notRequired(),
    conclusionStatement: account_intent_model_1.PromptContentSchema.notRequired(),
    parentIntentSignature: yup_lib_1.default.string().optional(),
    slots: yup_lib_1.default.array().of(exports.IIntentSlotSchema).optional()
});
exports.IBlueprintDataSchema = yup_lib_1.default.object().shape({
    intents: yup_lib_1.default.array().of(exports.IIntentSchema).required(),
    slotTypes: yup_lib_1.default.array().of(exports.ISlotTypeSchema).required()
});
